import React from 'react';
import { connect } from 'react-redux';
import PopUp from '@/components/contents/home/PopUp';
import SignUpContainer from '@/containers/content/user/SignUp/SignUpContainer';

function SignUpPage({ show }) {
    return (
        <>
            {show.status === 1 ? <PopUp /> : null}
            <div className="joinbox">
                <div className="sp20"></div>
                <SignUpContainer />
            </div>
        </>
    );
}

export default connect(
    (state) => ({
        show: state.widget.getIn(['modalStart', 'status']),
    }),
    null,
)(SignUpPage);
